/**
 * This file holds actions. The actions commit mutations and can perform asynchronous operations.
 * Please refer to https://vuex.vuejs.org/guide/actions.html for more information
 */
import * as types from "./types";
import http from "@/http";
import { randomizerData } from '@/data/modelsData';

const actions = {
  [types.SET_VIEWS]({ dispatch, commit, state }, isDesktop) {
    if (isDesktop) {
      state.views = ["select-style-view", "select-color-design-view", "randomizer-buy-panel-view"];
    } else {
      state.views = [
        "select-color-view",
        "select-style-view",
        "select-design-view",
        "randomizer-buy-panel-view"
      ];
    }

    if (state.modelStyles.length === 1) {
      const index = state.views.indexOf("select-style-view");
      state.views.splice(index, 1);

      const name = state.modelStyles[0];
      const { display_name, default_recipe, partnumber } = state.modelsData[name];

      const root = { root: true };
      const type = 'randomizer';

      commit('SET_SELECTED_STYLE', name);
      commit('SET_SELECTED_PRODUCT_NAME', display_name);
      dispatch('recipe/GET_RECIPE', {
        recipe_id: default_recipe,
        type,
        setData: true
      }, root)
        .then((data) => {
          commit('SET_DEFAULT_RECIPE', data);
          dispatch("utils/GET_AUDIENCE_SIZES", { partNumber: partnumber, type }, root)
      })
        .catch(err => console.error(err));
    }

    state.activeView = state.views[0];
  },

  [types.LOAD_SVG](context, url) {
    return new Promise((resolve, reject) => {
      http
        .get(url)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  [types.GET_RANDOMIZER_TILES]( {commit}, { data }) {
    commit('SET_CTA_TILES', data.tile_ids);

    const requestUrl = `${this.state.endPoints.randomizer.tiles}?tile_ids=[${data.tile_ids}]`;
    return new Promise((resolve, reject) => http
      .get(requestUrl)
      .then(({ data }) => resolve(data))
      .catch(reject)
    );
  },
  /**
   * Get selectable Styles.
   * TODO update with API
   */
  [types.FETCH_PRODUCT_DATA]() {
    return Promise.resolve(randomizerData);
  },
  /**
   * @deprecated
   */
  [types.GET_PRODUCT_DATA](context) {
    return new Promise(resolve => {
      const modelsData = {
        "sk8-hi": {
          display_name: "Sk8-hi",
          image: "sk8-hi.jpg",
          svg: "sk8-hi-left-view.svg",
          shadow: "shadow-map-left-view.png",
          punched_eyelts_shadow: "shadow-map-left-view-punched-eyelets.png",
          partnumber: "CSTSK8HiC",
          default_recipe: "000620d0a9208d6cdf29a12c5fd5ec87",
          featured_views: {
            buy_panel: {
              view: "left",
              size: "md"
            },
            mini_cart: {
              view: "left",
              size: "md"
            }
          }
        },
        "authentic-classic": {
          display_name: "Authentic",
          image: "authentic-classic.jpg",
          svg: "authentic-classic-left-view.svg",
          shadow: "shadow-map-left-view.png",
          punched_eyelts_shadow: "shadow-map-left-view-punched-eyelets.png",
          partnumber: "CSTAUTHCADT",
          default_recipe: "5d0d3ef661870a5a4e697f6b85a83285",
          featured_views: {
            buy_panel: {
              view: "left",
              size: "md"
            },
            mini_cart: {
              view: "left",
              size: "md"
            }
          }
        },
        "slip-on-classic": {
          display_name: "Slip On",
          image: "slip-on-classic.jpg",
          svg: "slip-on-classic-left-view.svg",
          shadow: "shadow-map-left-view.png",
          punched_eyelts_shadow: "shadow-map-left-view-punched-eyelets.png",
          partnumber: "CSTSLPONCADT",
          default_recipe: "bbeee49cf5e274086a179cf86622cee2",
          featured_views: {
            buy_panel: {
              view: "left",
              size: "md"
            },
            mini_cart: {
              view: "left",
              size: "md"
            }
          }
        },
        "era-classic": {
          display_name: "Era",
          image: "era-classic.jpg",
          svg: "era-classic-left-view.svg",
          shadow: "shadow-map-left-view.png",
          punched_eyelts_shadow: "shadow-map-left-view-punched-eyelets.png",
          partnumber: "CSTERAC",
          default_recipe: "63fa927383bf11586ca528a202d3efee",
          featured_views: {
            buy_panel: {
              view: "left",
              size: "md"
            },
            mini_cart: {
              view: "left",
              size: "md"
            }
          }
        },
        "old-skool-classic": {
          display_name: "Old Skool",
          image: "old-skool-classic.jpg",
          svg: "old-skool-classic-left-view.svg",
          shadow: "shadow-map-left-view.png",
          punched_eyelts_shadow: "shadow-map-left-view-punched-eyelets.png",
          partnumber: "CSTOLDSKLC",
          default_recipe: "eff610acffc76fdeeda6c759d57135a4",
          featured_views: {
            buy_panel: {
              view: "left",
              size: "md"
            },
            mini_cart: {
              view: "left",
              size: "md"
            }
          }
        },
        "backpack": {
          display_name: "Backpack",
          image: "backpack.jpg",
          svg: "backpack.svg",
          shadow: "shadow-map-front-view.png",
          punched_eyelts_shadow: "shadow-map-left-view-punched-eyelets.png",
          partnumber: "CSTBKP",
          default_recipe: "e7837e8d14459251e8e695317d8c531f",
          featured_views: {
            buy_panel: {
              view: "front",
              size: "md"
            },
            mini_cart: {
              size: "md-square-white",
              view: "front_white"
            }
          }
        }
      }
      resolve(modelsData);
    });
  },
  [types.LOAD_COMBINATIONS]({rootGetters}) {
    const selectedColors = rootGetters["randomizer/getSelectedColorsIds"];
    const requestUrl = `${this.state.endPoints.randomizer.combinations}/${this.state.randomizer.selectedStyle}?color_tiles=[${selectedColors.toString()}]&count=${this.state.randomizer.totalCombinations}`;

    return new Promise((resolve, reject) => {
      http
        .get(requestUrl)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  }
};

export default actions;
